<template>
  <div class="pk-flex pk-imageview">
    <div v-if="imageObj && imageObj.dbImageInfo && !imageObj.dbImageInfo.small"
     style="margin:50px 50px; z-index: 100; position:absolute;">
      <img src="../assets/icons/loading.gif"
       style="height:20px">
      <span v-if="imageObj && imageObj.dbImageInfo && imageObj.dbImageInfo.sourcename"> {{imageObj.dbImageInfo.sourcename}}</span>
    </div>
    <div class="pk-imageview-side pk-flex"
     style="margin-right:10px">
      <!-- <img src="../assets/icons/previous.svg"
       @click="prev"> -->
    </div>
    <div class="pk-flex__1 pk-imageview-body pk-flex__vh-center"
     style="position:relative; width:100%; height:100%; cursor: pointer;"
     @click="gotoSlide">
      <img v-if="imageObj && imageObj.dbImageInfo"
       :src="imageObj.dbImageInfo.small">
    </div>
    <div class="pk-imageview-side pk-flex"
     style="margin-left:10px; justify-content: flex-end;">
      <!-- <img src="../assets/icons/next.svg"
       @click="next"> -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      inputData: Object
    },
    data() {
      return {
        showLoading: false
      };
    },
    // mounted() {},
    computed: {
      imageObj() {
        return this.inputData ? this.inputData.$_screenImage : null;
      }
    },
    methods: {
      prev() {
        this.$store.dispatch('archive.select.prevSlideOfSlideset');
      },
      next() {
        this.$store.dispatch('archive.select.nextSlideOfSlideset');
      },
      gotoSlide() {
        if (!this.inputData) {
          return;
        }
        this.$routerUpdateQuery(this, {
          view: 's-objectview',
          thumbnail: 0,
          sid: this.inputData._id
        });
      }
    }
  };
</script>

<style scoped>
  .pk-imageview {
    height: 100%;
    background-color: #ddd;
  }
  
  .pk-imageview-body img {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
  }
  
  .pk-imageview-side {
    width: auto;
    align-items: flex-end;
  }
  
  .pk-imageview-side img {
    width: 35px;
    height: 35px;
    cursor: pointer;
  }
  
  .pk-imageview-side img:hover {
    background-color: #fff;
  }
</style>